import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const notificationCreate = (params = '') => Http.post('/create-notifications', params)

export const deleteScheduledNotification = params => Http.delete(`/scheduled-notifications/${params.id}`)
export const getScheduledNotifications = (params = '') => Http.get(`/scheduled-notifications${serialize(params)}`)
